import { MessageRetailerOrBrandButton, additionalDataRequiredForContactingRetailerOrBrandCTA } from "../../shared/instantAnswerUtils";
import { getViewOrderInvoiceCTA } from "./shared";
export var ReplacementItemsIA = function ReplacementItemsIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return INVOICE_UPDATES(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [INVOICE_UPDATES_EXPLANATION(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getViewOrderInvoiceC;
        return (_getViewOrderInvoiceC = getViewOrderInvoiceCTA(context, strictLocalize)) === null || _getViewOrderInvoiceC === void 0 ? void 0 : _getViewOrderInvoiceC.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getViewOrderInvoiceC2, _getViewOrderInvoiceC3;
        return (_getViewOrderInvoiceC2 = getViewOrderInvoiceCTA(context, strictLocalize)) === null || _getViewOrderInvoiceC2 === void 0 ? void 0 : (_getViewOrderInvoiceC3 = _getViewOrderInvoiceC2.getLink) === null || _getViewOrderInvoiceC3 === void 0 ? void 0 : _getViewOrderInvoiceC3.call(_getViewOrderInvoiceC2, context.brandOrder);
      }
    },
    secondaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _MessageRetailerOrBra;
        return (_MessageRetailerOrBra = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra === void 0 ? void 0 : _MessageRetailerOrBra.label;
      },
      onClickFunctionBuilder: function onClickFunctionBuilder(context) {
        var _MessageRetailerOrBra2;
        return (_MessageRetailerOrBra2 = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra2 === void 0 ? void 0 : _MessageRetailerOrBra2.onClick;
      }
    },
    additionalRequiredData: additionalDataRequiredForContactingRetailerOrBrandCTA()
  };
};
var INVOICE_UPDATES = function INVOICE_UPDATES(strictLocalize) {
  return strictLocalize({
    id: "wkZDOi",
    defaultMessage: [{
      "type": 0,
      "value": "Mises à jour des factures pour les articles de remplacement"
    }]
  });
};
var INVOICE_UPDATES_EXPLANATION = function INVOICE_UPDATES_EXPLANATION(strictLocalize) {
  return strictLocalize({
    id: "ZQTGxh",
    defaultMessage: [{
      "type": 0,
      "value": "Si vous choisissez de remplacer des articles, les articles signalés seront supprimés de votre facture d'origine et une nouvelle commande sera créée pour que la marque puisse l'exécuter. Cette commande de remplacement vous sera alors facturée à la date d'échéance de votre nouvelle facture. Si vous avez des questions, n'hésitez pas à nous contacter."
    }]
  });
};